
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.isSubmitting = false;
      this.error = false;

      if (!this.form || !this.submitButton) return;

      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.disabled = false;

      this.spinner = this.querySelector('.loading--spinner');
      this.buttonText = this.submitButton.querySelector(
        '[data-add-to-cart-text]'
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    async onSubmitHandler(event) {
      event.preventDefault();

      if (
        this.isSubmitting ||
        !this.submitButton ||
        this.submitButton.disabled
      ) {
        return;
      }

      this.isSubmitting = true;
      this.error = false;
      this.handleErrorMessage();

      this.submitButton.disabled = true;
      this.submitButton.classList.add('loading');
      this.spinner?.classList.remove('hidden');
      this.buttonText?.classList.add('hidden');

      const formData = new FormData(this.form);
      const variantId = formData.get('id');

      try {
        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          const sections = this.cart.getSectionsToRender();

          if (Array.isArray(sections) && sections.length) {
            formData.set(
              'sections',
              sections.map(section => section.id).join(',')
            );

            formData.set(
              'sections_url',
              window.location.pathname
            );
          }
        }

        config.body = formData;

        const response = await fetch(
          routes.cart_add_url,
          config
        );

        const result = await response.json();

        if (!response.ok || result.status) {
          this.error = true;

          const message =
            result.description ||
            result.message ||
            'Unable to add this product to your cart.';

          this.handleErrorMessage(message);

          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: message,
            message: result.message || message
          });

          return;
        }

        if (!this.cart) {
          window.location.href = routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId
        });

        const stickyBar = document.querySelector(
          '.product-sticky-bar'
        );

        stickyBar?.classList.remove('is-visible');

        this.cart.renderContents(result);
        this.cart.classList.add('is-visible');

        if (typeof focusElement !== 'undefined') {
          focusElement = this.submitButton;
        }

        document.body.classList.add('overflow-hidden');

        this.cart.classList.remove('is-empty');

      } catch (error) {
        this.error = true;

        console.error('Add to cart failed:', error);

        this.handleErrorMessage(
          'Something went wrong. Please try again.'
        );

      } finally {
        this.isSubmitting = false;

        this.submitButton.classList.remove('loading');
        this.spinner?.classList.add('hidden');
        this.buttonText?.classList.remove('hidden');

        if (!this.error) {
          this.submitButton.disabled = false;
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      if (!this.errorMessageWrapper) {
        this.errorMessageWrapper =
          this.querySelector(
            '.product-form--error-message-wrapper'
          ) ||
          this.closest('product-card')?.querySelector(
            '.product-form--error-message-wrapper'
          );
      }

      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(
          '.product-form--error-message'
        );

      this.errorMessageWrapper.toggleAttribute(
        'hidden',
        !errorMessage
      );

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
